import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Use setTimeout to ensure scroll happens after DOM updates
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // Valid ScrollBehavior value
      });
    }, 0);
  }, [location.pathname, location.search]); // Trigger on both pathname and search parameter changes

  return null; // This component doesn't render anything
};

export default ScrollToTop; 